import { IsOptional, IsArray, IsIn, IsBoolean, IsString } from "class-validator";
import { Constants } from "@eagerdog/constants";

import { IShowPrintParams } from "./show-print-params.interface";

export class ShowPrintParamsDto implements IShowPrintParams {
  @IsOptional()
  show_element?: string;

  @IsOptional()
  level?: string;

  @IsOptional()
  section?: string;

  @IsOptional()
  @IsIn(Object.values(Constants.breed_filter_type))
  breed_filter_type?: 
    | typeof Constants.breed_filter_type.all 
    | typeof Constants.breed_filter_type.breeds 
    | typeof Constants.breed_filter_type.breed_groups;

  @IsOptional()
  @IsArray()
  breed_filters?: string[];

  @IsOptional()
  @IsArray()
  breed_group_filters?: string[];

  // sort order for judge's books (Nosework: run_order/placement; Precision Coursing: height_at_withers/armband)
  @IsOptional()
  @IsIn(["run_order", "placement", "height_at_withers", "armband"])
  judge_books_sort?: "run_order" | "placement" | "height_at_withers" | "armband";

  // to get specific builder, not default one
  @IsOptional()
  builder_suffix?: string;

  // for small ribbon labels (Avery 5260)
  @IsOptional()
  @IsBoolean()
  small?: boolean;

  // for UKC Nosework 5162 ribbon labels (Avery 5162)
  @IsOptional()
  @IsBoolean()
  format_5162?: boolean;

  // for individual scoresheet download
  @IsOptional()
  @IsString()
  score_id?: string;

  // AKC Herding scoresheets: whether to include blank scoresheets for
  // waitlisted "-ALT" alternates alongside real entries.
  @IsOptional()
  @IsBoolean()
  include_alternates?: boolean;
}
